import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getsubscriberHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "subscriber", ...action.payload }),
		);
		yield put({
			type: types.GET_SUBSCRIBER_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_SUBSCRIBER_ERROR,
			payload,
		});
	}
}

export function* getsubscriberWatcherSaga() {
	yield takeLatest(types.GET_SUBSCRIBER_START, getsubscriberHandlerSaga);
}

//create

//delete

function* deletesubscriberHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("subscriber", action.payload),
		);
		yield put({
			type: types.DELETE_SUBSCRIBER_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_SUBSCRIBER_ERROR,
			payload,
		});
	}
}

export function* deletesubscriberWatcherSaga() {
	yield takeLatest(types.DELETE_SUBSCRIBER_START, deletesubscriberHandlerSaga);
}

//update
